import {
	primaryColor,
	blackColors,
	grayColor,
	backgroundColor,
	support3Color,
} from 'assets/jss/material-dashboard-pro-react';

const accordionStyle = (theme) => ({
	root: {
		flexGrow: 1,
	},
	iconWrapper: {
		padding: '8px !important',
		display: 'inline-flex',
		borderRadius: 8,
	},
	expansionPanel: {
		boxShadow: 'none',
		'&:before': {
			display: 'none !important',
		},
	},
	expansionPanelExpanded: {
		margin: '0 !important',
	},
	expansionPanelSummary: {
		minHeight: 'auto !important',
		backgroundColor: 'transparent',
		borderBottom: '1px solid ' + backgroundColor[0],
		padding: '0 8px 0 8px',
		height: '64px',
		borderTopLeftRadius: '3px',
		borderTopRightRadius: '3px',
		transition: 'all .1s ease-in-out',
		color: grayColor[2],
		'&:hover': {
			color: primaryColor[0],
			'& .MuiSvgIcon-root': {
				color: support3Color[0],
			},
		},
		'& *': {
			margin: 0,
			padding: 0,
		},
		'&.Mui-disabled': {
			opacity: 0.5,
		},
	},
	expansionPanelSummaryExpanded: {
		color: primaryColor[0],
		'& $expansionPanelSummaryExpandIcon': {
			color: support3Color[0],
			[theme.breakpoints.up('md')]: {
				top: 'auto !important',
			},
			transform: 'rotate(180deg)',
			[theme.breakpoints.down('sm')]: {
				top: '10px !important',
			},
		},
		'& p:first-of-type': {
			fontWeight: 'bold!important',
		},
	},
	expansionPanelSummaryContent: {
		margin: '0 !important',
		display: 'flex',
		alignItems: 'center',
	},
	expansionPanelSummaryExpandIcon: {
		transform: 'rotate(0deg)',
		position: 'static',
		transition: 'all .3s ease-in-out',
		color: blackColors[3],
	},
	expansionPanelSummaryExpandIconExpanded: {},
	title: {
		marginTop: '0',
		marginBottom: '0',
		marginLeft: 8,
		width: '100%'
	},
	expansionPanelDetails: {
		padding: 0,
		'& > div': {
			width: '100%',
		},
	},
});

export default accordionStyle;
